export const DEFAULT_MIXPANEL_ENABLED = false;
